// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1F2eV","empty":"ModalGraph_empty__10lUR"};